<template>
	<dl class="buyAnimalQty sort-item"
		v-if="ptInitData.productInfo.HANBAI_FLG == 1 && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn) && ptInitData.auraOpt == 1">
		<!-- 匹数 -->
		<span hidden id="buyAnimalQty_lbl">{{ $t('common.labels.animalQty') }}</span>
		<dt>{{ $t('common.labels.animalQty') }}</dt>
		<!--テキスト-->
		<dd>
			<input-check type="text" :maxlength="7" class="buyAnimalQty num" v-model="pt125ReqModel.animalQty"
				:name="'buyAnimalQty'" id="buyAnimalQty" style="width: 85px !important;"
				@on-change="getItemQty(pt125ReqModel.animalQty, ptInitData.qtyMin)" :value="0"
				:disabled="ptInitData.qtyMin === 1 ? true : false" />
		</dd>
	</dl>
</template>
<script>
import InputCheck from "components/InputCheck.vue";

export default {
	components: {
		InputCheck
	},

	methods: {
		getItemQty(qty, minQty) {
			this.$emit('getItemQty', qty, minQty)
		}
	},
	name: 'buyAnimalQty',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		pt125ReqModel: {
			type: Object,
			default: null
		},
	}
}
</script>